export const UA = window.navigator.userAgent.toLowerCase();
